import { OSKSize } from '../../types/osk-theme.types';

/** Icon size (px) matching each control size, shared by <osk-button> and <osk-avatar>. */
export const OSK_ICON_SIZE_BY_CONTROL_SIZE: Readonly<Record<OSKSize, number>> = {
  sm: 14,
  md: 16,
  lg: 18
};

/** Normalizes a CSS length input: numbers become px, strings are trimmed, empty values become null. */
export function toOSKCssLength(value: string | number | null | undefined): string | null {
  if (value === undefined || value === null) {
    return null;
  }
  if (typeof value === 'number') {
    return `${value}px`;
  }
  const trimmed = value.trim();
  return trimmed || null;
}
